module.exports = __webpack_public_path__ + "static/media/platinum-partner4.31fbd2d7.png";